import React from "react";
import HeroErrorWrapper from "../../HeroErrorWrapper";
import { Link } from "react-router-dom";
import Search from "../../Search";
import Preview from "../../Preview";
import { Button } from "reactstrap";
import { useGetFeaturedListingsQuery } from "../../../services/dataSystemsAPI";
import { useOopsMessage } from "./hooks/useOopsMessage";

/**
 * NotFound component
 * @param {object} props
 * @param {object} props.children - The children to render if not a 404 page
 * @returns {JSX.Element} - The NotFound component
 */
const NotFoundPage = () => {
    const { data: listingsPreview } = useGetFeaturedListingsQuery();
    const { partOne, partTwo, href, linkText } = useOopsMessage();

    const handleLink = (e, path) => {
        e.preventDefault();
        window.location = path;
    };

    return (
        <>
            <HeroErrorWrapper className="w-100" data-test="page-not-found">
                <h2 className="h1">Oops!</h2>
                <p className="fs-5">
                    {partOne}
                    {href && (
                        <Link to={href} onClick={(e) => handleLink(e, href)}>
                            {linkText}
                        </Link>
                    )}
                    {partTwo}
                </p>
            </HeroErrorWrapper>
            <div className="container-lg my-5">
                <div className="d-flex w-100 justify-content-center mb-5">
                    <div className="w-50">
                        <Search />
                    </div>
                </div>
                {listingsPreview && (
                    <div className="mb-5">
                        <h2 className="border-bottom">
                            {listingsPreview?.dataSetTitle}
                        </h2>
                        <p>
                            While you’re here, here are some of our featured
                            properties.
                        </p>
                        <Preview
                            className="preview"
                            listings={listingsPreview?.results}
                            shouldReload={true}
                        />
                    </div>
                )}
                <div className="d-flex w-100 justify-content-center">
                    <Button
                        color="primary"
                        href="/"
                        onClick={(e) => handleLink(e, "/")}
                    >
                        Visit Our Home Page
                    </Button>
                </div>
            </div>
        </>
    );
};

export default NotFoundPage;
